import { Center, Row } from "@/shared/ui/Blocks";
import { IconButton } from "@/shared/ui/IconButton";
import React from "react";
import { Notification } from "@/shared/services/api/graphql/generated";
import { DropdownMenu, DropdownMenuProps } from "@/shared/widgets/DropdownMenu";
import { useNavigate } from "react-router";
import { cn } from "@/shared/utils/shadcn";
import { SidebarLink } from "@/shared/widgets/Sidebar/SidebarLink";

interface NotificationButtonProps
  extends Omit<DropdownMenuProps, "items" | "trigger"> {
  notifications: Notification[];
  notificationCount: number;
  loading: boolean;
  showLabel?: boolean;
}

const NotificationButton = (props: NotificationButtonProps) => {
  const {
    notifications,
    notificationCount,
    loading,
    showLabel,
    ...dropdownMenuProps
  } = props;

  const navigate = useNavigate();

  return (
    <Row className={cn(showLabel && "w-full flex-1")}>
      <DropdownMenu
        items={notifications.map((notification) => ({
          label: notification.message || "",
          onClick: () => {
            navigate(notification.url || "/");
          },
        }))}
        {...dropdownMenuProps}
        trigger={
          <Row className="relative w-full">
            <SidebarLink
              key="notifications"
              icon="Bell"
              label="Notifications"
              isExpanded={showLabel}
            />
            {notificationCount > 0 && (
              <Center
                className={cn(
                  "w-4 h-4 bg-orange-500 rounded-full absolute top-0 right-0",
                  showLabel && "translate-y-1/2 right-2"
                )}
              >
                <span className="text-2xs text-white">{notificationCount}</span>
              </Center>
            )}
          </Row>
        }
      />
    </Row>
  );
};

export default NotificationButton;
